<ng-container [ngSwitch]="appliedTag.tag.tagType">

  <ng-container *ngSwitchCase="'Shift'">
    <div class="pos-relative mb-0050 col__ col__md--75 txt-14">
      <div class="mb-0050 w-100"
           title="Name: {{appliedTag.tag.name}}">{{appliedTag.tag.name}}
        <ng-container *ngIf="attachmentsEnabled"
                      [ngTemplateOutlet]="attachmentTmpl"
                      [ngTemplateOutletContext]="
                      {
                        attachments: appliedTag.attachments
                      }
                      ">
        </ng-container>
      </div>
      <div class="table note pos-relative">
        <div class="tr tile__heading tr--baseline tr--noGutter pos-absolute p-0 border-bottom-0">
          <button class="drawer__btn"
                  *ngIf="canEdit(appliedTag)"
                  mat-button
                  type="button"
                  (click)="editShiftClicked(appliedTag.shift)">
            <i class="far fa-fw fa-pencil fa--gray txt-14 color--blue"></i>
          </button>
        </div>
        <div class="tr tr--noGutter note__main">
          <div class="tr__content w-100">
            <app-shift-response-view [shift]="appliedTag.shift"
                                     [shiftTitle]="appliedTag.tag.name"
                                     class="d-block w-100"></app-shift-response-view>
          </div>
        </div>
      </div>
    </div>

    <div class="col__ col__md--20 mt-0050 mb-0050 mt-0--md mb-0--md pr-0050 color--gray txt-12 align-right--md"
         title="{{appliedTag.createdAt|date:'medium'}}">
      {{appliedTag.createdAt|relativeDate}}</div>
  </ng-container>

  <ng-container *ngSwitchCase="'Standard'">
    <div class="tc tc--sm tc--50"
         title="Name: {{appliedTag.tag.name}}">
      {{appliedTag.tag.name}}
      <ng-container *ngIf="attachmentsEnabled"
                    [ngTemplateOutlet]="attachmentTmpl"
                    [ngTemplateOutletContext]="{attachments: appliedTag.attachments}">
      </ng-container>
    </div>
    <div class="tc tc--light tc--xs tc--45 tc--right"
         title="{{appliedTag.createdAt|date:'medium'}}">
      {{appliedTag.createdAt|relativeDate}}</div>
  </ng-container>

  <ng-container *ngSwitchCase="'Address'">
    <div class="tc tc--sm tc--30"
         title="Name: {{appliedTag.tag.name}}">{{appliedTag.tag.name}}
      <ng-container *ngIf="attachmentsEnabled"
                    [ngTemplateOutlet]="attachmentTmpl"
                    [ngTemplateOutletContext]="{attachments: appliedTag.attachments}">
      </ng-container>
    </div>
    <div class="tc tc--xs tc--45">
      <full-address [address]="appliedTag.tag.address"></full-address>
    </div>
    <div class="tc tc--light tc--right tc--xs tc--20"
         title="{{appliedTag.createdAt|date:'medium'}}">
      {{appliedTag.createdAt|relativeDate}}</div>
  </ng-container>

  <ng-container *ngSwitchCase="'Notes'">
    <div class="tc tc--sm tc--30"
         title="Name: {{appliedTag.tag.name}}">{{appliedTag.tag.name}}
      <ng-container *ngIf="attachmentsEnabled"
                    [ngTemplateOutlet]="attachmentTmpl"
                    [ngTemplateOutletContext]="{attachments: appliedTag.attachments}">
      </ng-container>
    </div>
    <div class="tc tc--xs tc--45">
      <span *ngIf="appliedTag.notes.length === 0 && canEdit(appliedTag)"
            class="link"
            (click)="addNoteClicked(appliedTag)"
            data-test-id="addNoteToTagLinkInline">Add a note for this response.</span>
      <app-view-notes *ngIf="appliedTag.notes.length != 0"
                      class="noteList"
                      [preventEdit]="!canEdit(appliedTag)"
                      [notes]="appliedTag.notes"
                      [targetType]="'TaggableLogbook'"
                      [targetId]="appliedTag.id"></app-view-notes>
    </div>

    <div class="tc tc--light tc--right tc--xs tc--20"
         title="{{appliedTag.createdAt|date:'medium'}}">
      {{appliedTag.createdAt|relativeDate}}</div>
  </ng-container>

  <ng-container *ngSwitchCase="'Date'">
    <div class="tc tc--sm tc--30"
         title="Name: {{appliedTag.tag.name}}">{{appliedTag.tag.name}}
      <ng-container *ngIf="attachmentsEnabled"
                    [ngTemplateOutlet]="attachmentTmpl"
                    [ngTemplateOutletContext]="{attachments: appliedTag.attachments}">
      </ng-container>
    </div>
    <div class="tc tc--xs tc--45">
      <span *ngIf="appliedTag.notes.length === 0 && canEdit(appliedTag)"
            class="link"
            (click)="addNoteClicked(appliedTag)"
            data-test-id="addNoteToTagLinkInline">Add a date for this response.</span>
      <span *ngIf="appliedTag.notes.length > 0">
        {{appliedTag.notes[0]?.text | date:short}}
      </span>
    </div>
    <div class="tc tc--light tc--right tc--xs tc--20"
         title="{{appliedTag.createdAt|date:'medium'}}">
      {{appliedTag.createdAt|relativeDate}}</div>
  </ng-container>

  <ng-container *ngSwitchCase="'Number'">
    <div class="tc tc--sm tc--30"
         title="Name: {{appliedTag.tag.name}}">{{appliedTag.tag.name}}
      <ng-container *ngIf="attachmentsEnabled"
                    [ngTemplateOutlet]="attachmentTmpl"
                    [ngTemplateOutletContext]="{attachments: appliedTag.attachments}">
      </ng-container>
    </div>
    <div class="tc tc--xs tc--45">
      <span *ngIf="appliedTag.notes.length === 0 && canEdit(appliedTag)"
            class="link"
            (click)="addNoteClicked(appliedTag)"
            data-test-id="addNoteToTagLinkInline">Add a number for this response.</span>
      <span *ngIf="appliedTag.notes.length > 0">
        {{appliedTag.notes[0]?.text | number}}
      </span>

    </div>
    <div class="tc tc--light tc--right tc--xs tc--20"
         title="{{appliedTag.createdAt|date:'medium'}}">
      {{appliedTag.createdAt|relativeDate}}</div>
  </ng-container>

  <!-- Drawer button -->
  <div class="tr__drawer tr__drawer--sm  drawer">
    <ng-container *ngIf="canEdit(appliedTag)">
      <button class="drawer__btn"
              type="button"
              [matMenuTriggerFor]="tagMenu">
        <i class="far fa-fw fa-ellipsis-h fa--gray"></i>
      </button>

      <mat-menu #tagMenu="matMenu">
        <button mat-menu-item
                data-test-id="addNoteToTagLink"
                *ngIf="appliedTag.tag.tagType == 'Notes' && !appliedTag.notes"
                (click)="addNoteClicked(appliedTag)">
          Add Note
        </button>
        <button mat-menu-item
                *ngIf="appliedTag.tag.tagType == 'Shift' && appliedTag.shift"
                (click)="editShiftClicked(appliedTag.shift)">
          Edit Shift Info
        </button>
        <ng-container *ngIf="attachmentsEnabled">
          <button mat-menu-item
                  *ngIf="!hasAttachment(appliedTag)"
                  (click)="addFileClicked(appliedTag)">
            <span class="link link--noline"
                  data-test-id="">Add File</span>
          </button>
          <button *ngIf="hasAttachment(appliedTag)"
                  (click)="removeFileClicked(appliedTag)"
                  mat-menu-item>
            <span class="link link--noline"
                  data-test-id="">Remove File</span>
          </button>
        </ng-container>
        <button mat-menu-item
                (click)="removeTagClicked(appliedTag)">
          <span class="link link--noline link--red"
                data-test-id="removeTagLink">Remove Info</span>
        </button>
      </mat-menu>
    </ng-container>
    <ng-container *ngIf="!canEdit(appliedTag)">
      <mat-icon fontSet="fal"
                fontIcon="fa-ban"
                class="color--gray"></mat-icon>
    </ng-container>
  </div>
</ng-container>

<ng-template #attachmentTmpl
             let-attachments="attachments">
  <ng-container>
    <app-attachment-button *ngIf="attachments?.length > 0"
                           [attachment]="attachments[0]">
    </app-attachment-button>
  </ng-container>
</ng-template>
